module.exports = "/fonts/vendor/quasar-extras/roboto-web-KFOmCnqEu92Fr1Mu4mxM.woff?bafb105baeb22d965c70fe52ba6b49d9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/roboto-font/web-font/KFOmCnqEu92Fr1Mu4mxM.woff
// module id = meJF
// module chunks = 49